<template>
    <span class="l-news">
        <div class="c-block__headings">
            <h2 v-if="isImportant==true">グラジャパ！からのイベント情報</h2>
            <h2 v-else>イベント情報一覧</h2>
        </div>
        <div class="l-news__list">
            <dl v-if="eventLists.length == 0">
                <dd>現在イベント情報はありません。</dd>
            </dl>
            <dl v-for="(item, index) in eventLists" :key="index">
                <dt>{{ item.date }}</dt>
                <dd><a :href="item.url" v-html="item.title"></a></dd>
            </dl>
        </div>
    </span>
</template>

<script>
export default {
    props: [
        'eventLists',
        'isImportant'
    ],
}
</script>

<style lang="scss" scoped>
.l-news{
    font-size: 1.3rem;
    line-height: 1.7;
    padding: 0 0 100px;
    @media screen and (max-width: 767px) {
        padding: 0 0 55px;
        font-size: 14px;
    }
    .c-block__headings{
        margin: 0 0 20px;
    }
    .l-news__list{
        margin: 0 0 60px;
        @media screen and (max-width: 767px) {
            margin: 0 0 40px;
        }
        dl{
            padding: 20px 0;
            border-bottom: 1px solid #dce8ec;
            @media screen and (max-width: 767px) {
                padding: 15px 0;
            }
            dt{
                font-size: 1.1rem;
                color: #85949e;
                margin: 0 0 3px;
            }
            dd{
                a{
                    color: #00b3d6;
                    font-weight: bold;
                    &:hover{
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .label-priority {
        background-color: #FF0000;
        color: #FFFFFF;
        border-radius: 4px;
        display: inline-block;
        line-height: 20px;
        margin-left: 4px;
        padding: 0 8px;
        }
}
</style>